// src/analytics/index.ts
import ReactGA from "react-ga4";

export const initGA = () => {
   ReactGA.initialize("G-WFSM8PZSCS"); // Replace with your Measurement ID
};

export const logPageView = () => {
   ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};
export const logButtonClick = (buttonName: string) => {
   ReactGA.event({
      category: "Button",
      action: "Click",
      label: buttonName,
   });
};
